import { usePercentFormat } from '@enterprise/hooks';

import type { NumberFormatProps } from '#formats/types/number-format.props';

/**
 * React component for formatting a numeric value as a percentage.
 *
 * @param props - The properties for the PercentFormat component.
 * @param props.value - The numeric value to format as a percentage.
 * @param props.decimals - The number of decimal places to display.
 * @param props.fallback - The fallback string to display if the value is invalid or undefined. Defaults to '?'.
 * @returns A <span> element containing the formatted percentage value.
 *
 * @example
 * ```tsx
 * <PercentFormat value={0.1234} decimals={2} /> // renders "12.34%"
 * ```
 */
export const PercentFormat = ({ decimals, fallback = '?', value, ...props }: NumberFormatProps) => {
  return <span {...props}>{usePercentFormat(value, decimals, fallback)}</span>;
};
